import { render, staticRenderFns } from "./PlantingSocFarmerCreate.vue?vue&type=template&id=e8b4eebe"
import script from "./PlantingSocFarmerCreate.vue?vue&type=script&lang=js"
export * from "./PlantingSocFarmerCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports